const state = {
    waterfall: {},
    waterfallsales: {},
    waterfallebitda:{}
};

const getters = {
    waterfall: (state) => state.waterfall,
    waterfallsales: (state) => state.waterfallsales,
    waterfallebitda: (state) => state.waterfallebitda,
};

const actions = {
    
};

const mutations = {
    SET_WATERFALL: (state, waterfall) => {
        state.waterfall = waterfall;
    },
    SET_SALES: (state, waterfallsales) => {
        sessionStorage.setItem('waterfallsales',JSON.stringify(waterfallsales));
        state.waterfallsales = waterfallsales;
    },
    SET_EBITDA: (state, waterfallebitda) => {
        sessionStorage.setItem('waterfallebitda',JSON.stringify(waterfallebitda));
        state.waterfallebitda = waterfallebitda;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
}